export const landingPageTheme = {
  btnColor: 'var(--color-2)',
  btnTextColor: 'var(--color-4)',
  formColor: 'var(--color-3)',
  h1Color: 'var(--color-5)',
  optionColor: 'var(--color-3)',
  errorMessageColor: 'var(--color-2)',
  focusColor: 'var(--color-2)'
};

export const fieldPageTheme = {
  textColor: 'var(--color-3)',
  h1Color: 'var(--color-3)',
  btnColor: 'var(--color-3)',
  btnTextColor: 'var(--color-4)',
  labelColor: 'var(--color-5)',
  pBarColor: 'var(--color-3)',
  pBarBgColor: 'var(--color-4)',
  pBarValueColor: 'var(--color-1)',
  submitBtnColor: 'var(--color-2)',
  submitBtnTextColor: 'var(--color-4)'
};

export const ratingPageTheme = {
  textColor: 'var(--color-5)',
  h1Color: 'var(--color-2)',
  btnColor: 'var(--color-2)',
  btnTextColor: 'var(--color-4)',
  ratingBarColor: 'var(--color-1)',
  selected: 'var(--color-3)',
  labelColor: 'var(--color-5)'
};

export const gameOverPageTheme = {
  textColor: 'var(--color-5)',
  h1Color: 'var(--color-3)',
  btnColor: 'var(--color-3)',
  btnTextColor: 'var(--color-4)'
};

export const badgePageTheme = {
  textColor: 'var(--color-5)',
  badgeTextColor: 'var(--color-2)',
  h1Color: 'var(--color-3)',
  btnColor: 'var(--color-3)',
  btnTextColor: 'var(--color-4)',
  borderColor: 'var(--color-1)',
  badgeGreyColor: 'var(--color-1)'
};

export const casesPageTheme = {
  textColor: 'var(--color-3)',
  h1Color: 'var(--color-5)',
  btnColor: 'var(--color-3)',
  btnTextColor: 'var(--color-4)',
  borderColor: 'var(--color-1)',
  badgeGreyColor: 'var(--color-1)',
  badgeTextColor: 'var(--color-2)'
};

export const caseIntroPage = {
  textColor: 'var(--color-4)',
  h1Color: 'var(--color-4)',
  btnColor: 'var(--color-4)',
  btnTextColor: 'var(--color-6)',
  borderColor: 'var(--color-4)',
  bgColor: 'var(--color-6)'
};

export const navBarTheme = {
  pBarColor: 'var(--color-3)',
  pBarBgColor: 'var(--color-4)',
  pBarValueColor: 'var(--color-3)',
  darkBgColor: 'var(--color-4)',
  lightBgColor: 'var(--color-6)',
  labelColor: 'var(--color-5)',
};
